import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { QUOTEMEDIA_SP500_LIST_BASE_PATH } from '../../../../../../../../../features/vendor/quotemedia/sp500-list/quotemedia-sp500-list-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'quote-media-sp-500-list',
        label: 'QuoteMedia',
        to: QUOTEMEDIA_SP500_LIST_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
